import {findAll, onReady} from "../../../../modules/vegas/js/util";
import {VGFiles} from "vgfiles";


function init() {
	[...findAll('.vg-files')].map((files) => {
		new VGFiles(files);
	});
}

onReady(init);
typeof onTurboRender !== 'undefined' && onTurboRender(init);